import { render, staticRenderFns } from "./LearnStarter.vue?vue&type=template&id=4340ab9b&scoped=true&"
import script from "./LearnStarter.vue?vue&type=script&lang=js&"
export * from "./LearnStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4340ab9b",
  null
  
)

export default component.exports